import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
} from "@mui/material";
import ErrorMessage from "../../common/ErrorMessage/ErrorMessage";
import LoadingOverlay from "../../common/LoadingOverlay";
import { Delete } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Exception,
  TrailerEvent,
  TrailerEventInput,
} from "../../../graphql/generated";
import { useEffect, useState } from "react";
import TrailerEventForm from "./TrailerEventForm";
import { testIds } from "./TrailerEventFormModal.testIds";

export default function TrailerEventFormModal({
  trailerEvent,
  onDeleteTrailerEvent,
  onClose,
  onSaveTrailerEvent,
  isOpen,
  loading,
}: {
  trailerEvent?: TrailerEvent | null;
  onDeleteTrailerEvent: (id: string) => Promise<void>;
  onClose: () => void;
  onSaveTrailerEvent: (trailerEvent: TrailerEventInput) => Promise<void>;
  isOpen: boolean;
  loading: boolean;
  error: Exception | null;
}) {
  const [localTrailerEvent, setLocalTrailerEvent] =
    useState<Partial<TrailerEvent> | null | undefined>(trailerEvent);

  useEffect(() => {
    setLocalTrailerEvent(trailerEvent);
  }, [trailerEvent]);

  return (
    <Dialog maxWidth="sm" fullWidth open={isOpen} onClose={onClose}>
      <DialogTitle variant="h6">{"Trailer Event"}</DialogTitle>
      <DialogContent dividers sx={{ p: 2 }}>
        <ErrorMessage error={null} />
        <LoadingOverlay loading={loading} />
        <TrailerEventForm
          trailerEvent={localTrailerEvent}
          onChange={(trailerEvent) => {
            setLocalTrailerEvent(trailerEvent);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Stack direction="row" justifyContent="space-between" flex={1}>
          {trailerEvent ? (
            <IconButton data-testid={testIds.trailerEventFormModalDeleteEvent} onClick={() => onDeleteTrailerEvent(trailerEvent._id)}>
              <Delete />
            </IconButton>
          ) : (
            <Box />
          )}
          <Stack direction="row" spacing={2}>
            <Button data-testid={testIds.trailerEventFormModalCancel}
              autoFocus
              color="inherit"
              variant="contained"
              onClick={onClose}
            >
              Close
            </Button>
            <LoadingButton data-testid={testIds.trailerEventFormModalSave}
              color="primary"
              variant="contained"
              onClick={() =>
                onSaveTrailerEvent(localTrailerEvent as TrailerEventInput)
              }
              id="save-event-button"
              loading={loading}
            >
              Save
            </LoadingButton>
          </Stack>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
